export default class AlertModel {
  constructor(message, type) {
    this.Message = message;
    this.Type = type;
    //this.DismissSecs = 30;
    //this.DismissCountDown = 0;
  }
}
